<template>
    <li
        class="house-grid-item layout13"
        :class="{ 'house-sold': soldDate }"
        :title="address"
        @click="openDetail(link, $event)"
    >
        <article>
            <a
                class="house-preview"
                :href="linkData.href"
                :target="linkData.target"
                :aria-label="linkData['aria-label']"
                :self="linkData.self"
            >
                <site-img
                    v-if="firstImage"
                    :src="firstImage"
                    :errorImg="defHouseImg"
                    dir="width"
                />
                <div v-else class="default-img">
                    <site-img :src="picSrc" dir="width" />
                </div>
                <div class="house-status-container" v-if="!soldDate && (exclusiveTag || tag)">
                    <house-tag
                        theme="layout13"
                        v-if="exclusiveTag"
                        v-bind="exclusiveTag"
                    />
                    <house-tag theme="layout13" v-bind="tag" v-if="tag" />
                    <!-- <span v-if="tour3D" class="house-count">
                        <i class="iconfont icon-3d"></i>
                        {{ $t('md-house.3d') }}
                    </span> -->
                </div>
                <p
                    class="collect"
                    :class="{
                        collected: heartActive || collected
                    }"
                    v-if="!soldDate && !widget"
                    @click.stop.prevent="collect"
                >
                    <span class="icon-fav">
                        <i
                            class="iconfont icon-heart-fill"
                            :class="{
                                active: heartActive || collected
                            }"
                        ></i>
                        <i
                            class="iconfont icon-heart"
                            :class="{
                                disactive: !(heartActive || collected)
                            }"
                        ></i>
                    </span>
                </p>
                <house-mask v-if="isShowMask" display="fill-up" />
            </a>
            <only-client>
                <p v-if="soldDate" :class="['house-sold-date', statusOrigin]">
                    <span>{{
                        $t('md-house.soldOn', {
                            soldDate: $ft.formatDate(soldDate, 'MM/dd/yyyy')
                        })
                    }}</span>
                </p>
            </only-client>
            <div class="house-body">
                <div class="price-fav">
                    <title-mask-v2 v-if="isShowMask" />
                    <no-disclosure
                        v-else-if="!!house.nodisclosureDes || hidePrice"
                        :des="
                            hidePrice
                                ? $t('md-house.nondisclosure')
                                : house.nodisclosureDes
                        "
                    />
                    <template v-else-if="soldDate">
                        <div class="house-price-wrap">
                            <span class="house-sold-price">
                                <!-- {{ markPrice.replace(/\s/g, '') }} -->
                            {{ $ft.trim(markPrice) }}
                            </span>
                            <p>
                                <span
                                    class="house-initial-price"
                                    v-if="showAllPrice && initialPrice"
                                >
                                    {{ $ft.trim(initialPrice) }}
                                </span>
                                <HouseTrend
                                    v-if="showAllPrice && trend"
                                    :trendStatus="trendStatus"
                                    :trend="trend"
                                />
                            </p>
                        </div>
                    </template>
                    <div v-else class="house-price">
                        {{ price.replace(/\s/g, '') }}
                    </div>
                </div>
                <div class="house-basic clearfix">
                    <span
                        v-for="item in basic"
                        :key="item.key"
                        :class="['vertical-line', `house-${item.key}`]"
                        >{{ item.text }}</span
                    >
                </div>
                <h3 class="house-address">
                    <a
                        :href="linkData.href"
                        :target="linkData.target"
                        :aria-label="linkData['aria-label']"
                        :self="linkData.self"
                        >{{ address }}</a
                    >
                </h3>
                <div
                    class="house-footer"
                    :class="{ 'sold-footer': !!soldDate }"
                >
                    <div class="mls-text">
                        <p v-if="showMls" class="house-mls-id">
                            MLS# {{ mlsid }}
                        </p>
                        <p
                            v-if="!isShowMask && provided"
                            class="house-provided ws-pre-wrap"
                        >
                            {{ provided }}
                        </p>
                    </div>
                    <site-img
                        v-if="mlsLogo"
                        class="small-logo"
                        :src="mlsLogo"
                        :alt="mlsAlt"
                        dir="height"
                    />
                </div>
            </div>
        </article>
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </li>
</template>

<script>
import Item from '../item';
import HouseItem from '../house-item.js';
import OnlyClient from '@/components/global/only-client.vue';
export default {
    mixins: [HouseItem, Item],
    components: { OnlyClient },
    data() {
        return {
            picSrc: 'https://cdn.chime.me/image/fs/sitebuild/site-cms/md-house/layout6.png',
            // isShowMask: true
        };
    }
};
</script>
<style lang="scss">
@import '@/theme/mixin.scss';
@import '@/theme/media.scss';

.house-grid-item.layout13 {
    position: relative;
    display: flex;
    flex-direction: column;
    width: calc((100% - 16px * 2) / 3);

    &:hover {
        .house-address {
            font-weight: 700;
            text-decoration: underline;
        }
    }

    > article {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .house-preview {
        width: 100%;
        height: 230px;
        position: relative;
        overflow: hidden;

        img {
            position: absolute;
            width: 100%;
            height: 100%;
            object-fit: cover;
            top: 0;
            left: 0;
            transition: transform 0.3s ease;
        }

        &:hover {
            img {
                transform: scale(1.15);
            }
        }

        .default-img {
            width: 100%;
            height: 100%;
            background: rgba(218, 218, 218, 0.2);
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            img {
                width: 64px;
                height: 56px;
                opacity: 0.3;
                position: static;
            }
        }

        .c-house-mask.fill-up {
            background: rgba(255, 255, 255, 0.9);
            backdrop-filter: none;
            .mask-box .text {
                color: rgba(25, 25, 25, 1);
                font-family: var(--font-normal);
                p:last-child {
                    font-size: 12px;
                    line-height: 30px;
                    margin-bottom: 0;
                }
            }
        }
    }
    .md-house__mask {
        background: rgba(255, 255, 255, 0.9);
        .mask-box .mask-lock {
            width: 48px;
            height: 48px;
            line-height: 48px;
            background: rgba(255, 255, 255, 1);
            .icon-lock1 {
                font-size: 24px;
                color: #191919;
            }
        }
    }

    .house-sold-date {
        position: absolute;
        left: 20px;
        top: 20px;
        z-index: 2;

        span {
            font-family: var(--font-normal);
            font-size: 12px;
            font-weight: 700;
            height: 20px;
            line-height: 20px;
            padding: 0 5px;
            border-radius: 0;
            color: #fff;
            background-color: #505050;
        }
    }

    .house-status-container {
        position: absolute;
        top: 20px;
        left: 20px;
        right: 80px;
        z-index: 20;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 5px; 
        color: #fff;
        font-family: var(--font-normal);
        font-size: 12px;
        .house-status {
            height: 20px;
        }
        .house-status.layout13 {
            background: rgba(35, 200, 100, 1);
        }
    }
    .collect {
        position: absolute;
        right: 20px;
        top: 20px;
        z-index: 20;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        background: rgba(25, 25, 25, 0.5);
        box-shadow: 0px 5px 10px 0px rgba(60, 60, 76, 0.03);
        &.collected {
            background: rgba(255, 255, 255, 1);
        }
        .icon-fav {
            font-size: 20px;
            color: #fff;
            .icon-heart-fill {
                display: none;
                &.active {
                    display: inline;
                    color: #f0454c;
                }
            }
            .icon-heart {
                display: none;
                &.disactive {
                    display: inline;
                }
            }
        }
    }
    .house-count {
        // position: absolute;
        // top: 0;
        // right: 0;
        // z-index: 1;
        color: white;
        padding-left: 5px;
        padding-right: 5px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        display: flex;
        justify-content: center;
        background-color: rgba(0, 0, 0, 0.4);
        border-radius: 2px;
        .iconfont {
            margin-right: 5px;
        }
    }

    .house-body {
        flex: 1;
        position: relative;
        display: flex;
        flex-direction: column;
    }

    .house-property {
        color: var(--g-tip-color);
        font-size: 12px;
        line-height: 1;
        position: absolute;
        top: 28px;
        right: 0;
    }

    .price-fav {
        margin-top: 20px;

        @include media-600 {
            margin-top: 10px;
        }

        .nodisclosure {
            .dollar,
            .secret {
                color: var(--color-success);
            }
        }

        .house-price-wrap {
            display: flex;
            flex-wrap: wrap;

            & > p {
                display: flex;
                align-items: center;
                margin-bottom: 5px;
            }
        }

        .house-sold-price {
            font-family: var(--mg-title-font);
            color: var(--g-primary-color);
            font-size: 26px;
            line-height: 30px;
            margin-right: 10px;
            margin-bottom: 5px;
        }

        .house-initial-price {
            color: var(--g-tip-color);
            font-size: 16px;
            line-height: 20px;
            text-decoration: line-through;
            margin-right: 10px;
            font-weight: 400;
        }

        .house-price {
            font-family: var(--mg-title-font);
            color: var(--g-primary-color);
            font-size: 26px;
            line-height: 30px;
            display: flex;
            align-items: center;
        }
    }

    .house-basic {
        color: var(--g-text-color);
        font-size: 14px;
        line-height: 1.5;
        margin-top: 15px;

        @include media-600 {
            margin-top: 5px;
        }

        .vertical-line:after {
            content: '|';
            display: inline;
            margin: 0 8px;
            color: var(--color-border);
        }

        .vertical-line:nth-last-child(1):after {
            content: '';
        }
    }

    .house-address {
        color: var(--g-text-color);
        font-size: 14px;
        line-height: 1.5;
        @include webkitBox(2);
        margin-top: 5px;
    }

    .house-footer {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        gap: 20px;
        margin-top: 28px;
        .mls-text {
            flex: 1;
        }
        .house-mls-id,
        .house-provided {
            font-size: 12px;
            line-height: 14px;
            color: var(--g-tip-color);
            @include webkitBox(2);
        }

        .house-provided {
            margin-top: 5px;
        }
    }

    .small-logo {
        height: 24px;
    }

    @media (max-width: 900px) {
        width: calc((100% - 16px) / 2);
    }

    @include media-800 {
        width: 100%;
        .house-basic {
            margin-top: 5px;
        }
        .house-footer {
            margin-top: 5px;
        }
    }
}
</style>
